// import { useParams } from "react-router-dom";
import SalesForm from "../formBuilder/SalesForm";
import { useLocation } from "react-router-dom";
import { DraftEntryBoundary } from "../../context/drafts/DraftForm";

const DynamicTransactionPage = () => {
  const location = useLocation();
  // const { tab, category } = useParams();

  const renderComponent = () => {
    return <SalesForm />;
  };

  return <DraftEntryBoundary key={location.key}>{renderComponent()}</DraftEntryBoundary>;
};

export default DynamicTransactionPage;
